const THUMBNAIL_SIZE = 'hqdefault';

export const getPreviewURL = (id: string) => {
    return `https://i.ytimg.com/vi/${id}/${THUMBNAIL_SIZE}.jpg`
};
